import Vue from 'vue'
import VueRouter from 'vue-router'
import homeView from '../views/HomeView.vue'

Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    name: 'home',
    component: homeView,
    redirect: '/home',
    children: [
      {
        path: '/home',
        name: 'home',
        component: () => import('../views/HomePageView.vue')
      }
    ]
  }
]
const router = new VueRouter({
  mode: 'history',
  routes
  // scrollBehavior (to, from, savedPosition) {
  //   // 解决路由跳转后 会滚动到底部
  //   if (savedPosition) {
  //     return savedPosition
  //   } else {
  //     return { x: 0, y: 0 }
  //   }
  // }
})
// 路由守卫
export default router
